module.exports = __webpack_public_path__ + "static/live-3c03976b9db8413f377260ea56c1177a.jpg";